import { api } from '@/lib/api'

export type Preset = { name: string; params: Record<string, unknown>; created_at: string }

export const listPresets = (op: string) => api<Preset[]>(`/presets/${encodeURIComponent(op)}`)

export const savePreset = (op: string, name: string, params: Record<string, unknown>) =>
  api<Preset>(`/presets/${encodeURIComponent(op)}`, {
    method: 'POST',
    body: JSON.stringify({ name, params }),
  })

export const deletePreset = (op: string, name: string) =>
  api<{ deleted: string }>(
    `/presets/${encodeURIComponent(op)}/${encodeURIComponent(name)}`,
    { method: 'DELETE' },
  )
